import useQuery from "./useQuery";
import useQueryParamsController from "./useQueryParamsController";

interface QueryGetObject {
  [key: string]: any
}

interface QuerySetObject {
  [key: string]: any
}

interface QuerySetConfig {
  replace?: boolean;
}

const useQueryState = (): [QueryGetObject, (params: QuerySetObject, config?: QuerySetConfig) => void] => {
  const queryParams = useQuery()
  const setQueryParams = useQueryParamsController();

  return [queryParams, setQueryParams]
}

export default useQueryState;import useQuery from "./useQuery";
import useQueryParamsController from "./useQueryParamsController";

interface QueryGetObject {
  [key: string]: any
}

interface QuerySetObject {
  [key: string]: any
}

interface QuerySetConfig {
  replace?: boolean;
}

const useQueryState = (): [QueryGetObject, (params: QuerySetObject, config?: QuerySetConfig) => void] => {
  const queryParams = useQuery()
  const setQueryParams = useQueryParamsController();

  return [queryParams, setQueryParams]
}

export default useQueryState;